import { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

/**
 * Сортирует массив методов оплаты так, чтобы элементы с id 'card' или 'new-card'
 * всегда находились в конце массива, сохраняя исходный порядок остальных элементов
 *
 * @param methods - массив методов оплаты
 * @returns отсортированный массив методов оплаты
 */
export const sortPaymentMethods = (methods: IMethodData[]): IMethodData[] => {
    const result = methods.reduce(
        (acc: Record<string, IMethodData[]>, method: IMethodData) => {
            if (method.id === 'card' || method.id === 'new-card') {
                acc.cardMethods.push(method);
            } else {
                acc.otherMethods.push(method);
            }
            return acc;
        },
        { cardMethods: [], otherMethods: [] },
    );

    return [...result.otherMethods, ...result.cardMethods];
};
